import axios from "axios";
import { baseUrl } from "../data/constant";
import { useAuthContext } from "../contexts/AuthContext";
import { toast } from "react-toastify";
import { useState } from "react";

const DeleteUserModal = ({ onClose, data }) => {
  const { token } = useAuthContext();
  const [deleting, setDeleting] = useState(false);

  const deleteUser = async (userId) => {
    setDeleting(true);
    try {
      const { data } = await axios.delete(
        `${baseUrl}/user/delete-user/${userId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      if (data.success) {
        toast.success(data?.message || "User deleted successfully");
        onClose();
      }
    } catch (error) {
      console.error("Error deleting user:", error);
    } finally {
      setDeleting;
      false;
    }
  };

  const handleDelete = () => {
    if (data?._id) {
      deleteUser(data._id);
    } else {
      toast.error("User ID is missing. Cannot delete user.");
    }
  };

  return (
    <div className="w-full p-2">
      <h2 className="text-xl font-semibold mb-1">Delete User</h2>
      <p className="text-gray-500 dark:text-gray-400 mb-6 text-sm">
        This action is permanent and cannot be undone.
      </p>

      <div className="space-y-4 mb-8">
        <div className="bg-gray-50 dark:bg-gray-800 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
          <div className="font-medium text-lg mb-1">
            {data?.firstName} {data?.lastName}
          </div>
          <div className="text-sm text-gray-600 dark:text-gray-300 break-all">
            {data?.email}
          </div>
        </div>

        <p className="text-sm text-red-600 dark:text-red-400 font-medium">
          Are you sure you want to permanently delete this user?
        </p>
      </div>

      <div className="flex justify-end gap-3 mt-6">
        <button
          type="button"
          onClick={onClose}
          disabled={deleting}
          className={`
            px-5 py-2.5 rounded-lg font-medium
            border border-gray-300 dark:border-gray-600
            hover:bg-gray-100 dark:hover:bg-gray-700
            transition-colors
            disabled:opacity-50
          `}
        >
          Cancel
        </button>

        <button
          type="button"
          onClick={handleDelete}
          disabled={deleting}
          className={`
            px-5 py-2.5 rounded-lg font-medium text-white
            bg-red-600 hover:bg-red-700 active:bg-red-800
            focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2
            transition-colors
            disabled:opacity-50 disabled:cursor-not-allowed
            flex items-center gap-2
          `}
        >
          {deleting && (
            <span className="animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full" />
          )}
          {deleting ? "Deleting..." : "Delete User"}
        </button>
      </div>
    </div>
  );
};

export default DeleteUserModal;
